// import React, { useState, useEffect } from 'react';
// import { FaTimes } from 'react-icons/fa';

// const DepartmentForm = ({ 
//   isOpen, 
//   onClose, 
//   onSubmit, 
//   isEditMode, 
//   initialData, 
//   loading 
// }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     description: ''
//   });
//   const [formErrors, setFormErrors] = useState({});

//   useEffect(() => {
//     if (isOpen && initialData) {
//       setFormData({
//         name: initialData.name || '',
//         description: initialData.description || ''
//       });
//     } else if (isOpen && !initialData) {
//       setFormData({
//         name: '',
//         description: ''
//       });
//     }
//   }, [isOpen, initialData]);

//   // Form validation
//   const validateForm = () => {
//     const errors = {};

//     if (!formData.name.trim()) {
//       errors.name = 'Department name is required';
//     } else if (formData.name.trim().length < 3) {
//       errors.name = 'Department name must be at least 3 characters';
//     } else if (formData.name.trim().length > 50) {
//       errors.name = 'Department name must not exceed 50 characters';
//     }

//     if (formData.description && formData.description.length > 200) {
//       errors.description = 'Description must not exceed 200 characters';
//     }

//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   // Handle form input changes
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
    
//     // Clear error for this field when user starts typing
//     if (formErrors[name]) {
//       setFormErrors(prev => ({
//         ...prev,
//         [name]: ''
//       }));
//     }
//   };

//   // Handle form submission
//   const handleSubmit = (e) => {
//     e.preventDefault();
    
//     if (!validateForm()) {
//       return;
//     }

//     onSubmit(formData);
//   };

//   // Handle close
//   const handleClose = () => {
//     setFormData({
//       name: '',
//       description: ''
//     });
//     setFormErrors({});
//     onClose();
//   };

//   return (
//     <>
//       {/* Backdrop */}
//       <div 
//         className={`fixed inset-0 bg-black transition-opacity duration-300 z-50 ${
//           isOpen ? 'bg-opacity-50' : 'bg-opacity-0 pointer-events-none'
//         }`}
//         onClick={handleClose}
//       />

//       {/* Offcanvas */}
//       <div
//         className={`fixed top-0 right-0 h-full w-full max-w-md bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
//           isOpen ? 'translate-x-0' : 'translate-x-full'
//         }`}
//       >
//         <div className="h-full flex flex-col">
//           {/* Header */}
//           <div className="flex justify-between items-center p-6 border-b">
//             <h2 className="text-xl font-bold text-gray-800">
//               {isEditMode ? 'Edit Department' : 'Create New Department'}
//             </h2>
//             <button
//               onClick={handleClose}
//               className="text-gray-500 hover:text-gray-700 p-1"
//             >
//               <FaTimes className="text-xl" />
//             </button>
//           </div>

//           {/* Form */}
//           <div className="flex-1 overflow-y-auto p-6">
//             <form onSubmit={handleSubmit}>
//               <div className="mb-6">
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Department Name <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   name="name"
//                   value={formData.name}
//                   onChange={handleInputChange}
//                   className={`w-full px-3 py-2 text-sm sm:text-base border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${
//                     formErrors.name ? 'border-red-500' : 'border-gray-300'
//                   }`}
//                   placeholder="Enter department name"
//                 />
//                 {formErrors.name && (
//                   <p className="mt-1 text-sm text-red-600">{formErrors.name}</p>
//                 )}
//               </div>

//               <div className="mb-6">
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Description
//                 </label>
//                 <textarea
//                   name="description"
//                   value={formData.description}
//                   onChange={handleInputChange}
//                   rows="4"
//                   className={`w-full px-3 py-2 text-sm sm:text-base border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${
//                     formErrors.description ? 'border-red-500' : 'border-gray-300'
//                   }`}
//                   placeholder="Enter department description (optional)"
//                 />
//                 {formErrors.description && (
//                   <p className="mt-1 text-sm text-red-600">{formErrors.description}</p>
//                 )}
//                 <p className="mt-1 text-xs text-gray-500">
//                   {formData.description.length}/200 characters
//                 </p>
//               </div>

//               {/* Form Actions */}
//               <div className="flex gap-3 pt-4">
//                 <button
//                   type="button"
//                   onClick={handleClose}
//                   className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 text-sm sm:text-base transition-colors"
//                   disabled={loading}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className="flex-1 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base transition-colors"
//                   disabled={loading}
//                 >
//                   {loading ? 'Saving...' : (isEditMode ? 'Update' : 'Create')}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default DepartmentForm;

// import React, { useState, useEffect } from 'react';
// import { FaTimes } from 'react-icons/fa';

// const DepartmentForm = ({ 
//   isOpen, 
//   onClose, 
//   onSubmit, 
//   isEditMode,
//   isViewMode,
//   initialData, 
//   loading 
// }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     description: ''
//   });
//   const [formErrors, setFormErrors] = useState({});

//   useEffect(() => {
//     if (isOpen && initialData) {
//       setFormData({
//         name: initialData.name || '',
//         description: initialData.description || ''
//       });
//     } else if (isOpen && !initialData) {
//       setFormData({
//         name: '',
//         description: ''
//       });
//     }
//   }, [isOpen, initialData]);

//   // Form validation
//   const validateForm = () => {
//     const errors = {};

//     if (!formData.name.trim()) {
//       errors.name = 'Department name is required';
//     } else if (formData.name.trim().length < 3) {
//       errors.name = 'Department name must be at least 3 characters';
//     } else if (formData.name.trim().length > 50) {
//       errors.name = 'Department name must not exceed 50 characters';
//     }

//     if (formData.description && formData.description.length > 200) {
//       errors.description = 'Description must not exceed 200 characters';
//     }

//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   // Handle form input changes
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
    
//     // Clear error for this field when user starts typing
//     if (formErrors[name]) {
//       setFormErrors(prev => ({
//         ...prev,
//         [name]: ''
//       }));
//     }
//   };

//   // Handle form submission
//   const handleSubmit = (e) => {
//     e.preventDefault();
    
//     if (!validateForm() || isViewMode) {
//       return;
//     }

//     onSubmit(formData);
//   };

//   // Handle close
//   const handleClose = () => {
//     setFormData({
//       name: '',
//       description: ''
//     });
//     setFormErrors({});
//     onClose();
//   };

//   // Get form title
//   const getTitle = () => {
//     if (isViewMode) return 'View Department';
//     if (isEditMode) return 'Edit Department';
//     return 'Create New Department';
//   };

//   return (
//     <>
//       {/* Backdrop */}
//       <div 
//         className={`fixed inset-0 bg-black transition-opacity duration-300 z-50 ${
//           isOpen ? 'bg-opacity-50' : 'bg-opacity-0 pointer-events-none'
//         }`}
//         onClick={handleClose}
//       />

//       {/* Offcanvas */}
//       <div
//         className={`fixed top-0 right-0 h-full w-full max-w-md bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
//           isOpen ? 'translate-x-0' : 'translate-x-full'
//         }`}
//       >
//         <div className="h-full flex flex-col">
//           {/* Header */}
//           <div className="flex justify-between items-center p-6 border-b">
//             <h2 className="text-xl font-bold text-gray-800">
//               {getTitle()}
//             </h2>
//             <button
//               onClick={handleClose}
//               className="text-gray-500 hover:text-gray-700 p-1"
//             >
//               <FaTimes className="text-xl" />
//             </button>
//           </div>

//           {/* Form */}
//           <div className="flex-1 overflow-y-auto p-6">
//             <form onSubmit={handleSubmit}>
//               <div className="mb-6">
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Department Name {!isViewMode && <span className="text-red-500">*</span>}
//                 </label>
//                 <input
//                   type="text"
//                   name="name"
//                   value={formData.name}
//                   onChange={handleInputChange}
//                   disabled={isViewMode}
//                   className={`w-full px-3 py-2 text-sm sm:text-base border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${
//                     formErrors.name ? 'border-red-500' : 'border-gray-300'
//                   } ${isViewMode ? 'bg-gray-100 cursor-not-allowed' : ''}`}
//                   placeholder="Enter department name"
//                 />
//                 {formErrors.name && !isViewMode && (
//                   <p className="mt-1 text-sm text-red-600">{formErrors.name}</p>
//                 )}
//               </div>

//               <div className="mb-6">
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Description
//                 </label>
//                 <textarea
//                   name="description"
//                   value={formData.description}
//                   onChange={handleInputChange}
//                   disabled={isViewMode}
//                   rows="4"
//                   className={`w-full px-3 py-2 text-sm sm:text-base border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${
//                     formErrors.description ? 'border-red-500' : 'border-gray-300'
//                   } ${isViewMode ? 'bg-gray-100 cursor-not-allowed' : ''}`}
//                   placeholder="Enter department description (optional)"
//                 />
//                 {formErrors.description && !isViewMode && (
//                   <p className="mt-1 text-sm text-red-600">{formErrors.description}</p>
//                 )}
//                 {!isViewMode && (
//                   <p className="mt-1 text-xs text-gray-500">
//                     {formData.description.length}/200 characters
//                   </p>
//                 )}
//               </div>

//               {/* Form Actions */}
//               {!isViewMode && (
//                 <div className="flex gap-3 pt-4">
//                   <button
//                     type="button"
//                     onClick={handleClose}
//                     className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 text-sm sm:text-base transition-colors"
//                     disabled={loading}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     className="flex-1 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base transition-colors"
//                     disabled={loading}
//                   >
//                     {loading ? 'Saving...' : (isEditMode ? 'Update' : 'Create')}
//                   </button>
//                 </div>
//               )}

//               {isViewMode && (
//                 <div className="pt-4">
//                   <button
//                     type="button"
//                     onClick={handleClose}
//                     className="w-full px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 text-sm sm:text-base transition-colors"
//                   >
//                     Close
//                   </button>
//                 </div>
//               )}
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default DepartmentForm;

import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import { toast } from 'react-toastify';
import api from '../../common/apiClient';
import SummaryApi from '../../common/SummaryApi';

const DepartmentForm = ({ 
  isOpen, 
  onClose, 
  onSuccess, // Changed from onSubmit to onSuccess
  isEditMode,
  isViewMode,
  initialData, 
}) => {
  const [formData, setFormData] = useState({
    name: '',
    description: ''
  });
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && initialData) {
      setFormData({
        name: initialData.name || '',
        description: initialData.description || ''
      });
    } else if (isOpen && !initialData) {
      setFormData({
        name: '',
        description: ''
      });
    }
  }, [isOpen, initialData]);

  // Form validation
  const validateForm = () => {
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = 'Department name is required';
    } else if (formData.name.trim().length < 3) {
      errors.name = 'Department name must be at least 3 characters';
    } else if (formData.name.trim().length > 50) {
      errors.name = 'Department name must not exceed 50 characters';
    }

    if (formData.description && formData.description.length > 200) {
      errors.description = 'Description must not exceed 200 characters';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error for this field when user starts typing
    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm() || isViewMode) {
      return;
    }

    setLoading(true);
    try {
      let response;
      
      if (isEditMode && initialData?._id) {
        // Update department
        response = await api.put(
          SummaryApi.updateDepartment.url(initialData._id),
          formData
        );
      } else {
        // Create department
        response = await api.post(SummaryApi.createDepartment.url, formData);
      }

      if (response.data.success) {
        toast.success(`Department ${isEditMode ? 'updated' : 'created'} successfully`);
        
        // Call onSuccess callback if provided
        if (onSuccess) {
          onSuccess(response.data.data || response.data.department);
        }
        
        // Close the form
        handleClose();
      } else {
        toast.error(response.data.message || `Failed to ${isEditMode ? 'update' : 'create'} department`);
      }
    } catch (error) {
      console.error('Operation failed:', error);
      
      // Handle specific error cases
      if (error.response?.status === 409) {
        toast.error('Department with this name already exists');
      } else if (error.response?.status === 400) {
        toast.error(error.response.data.message || 'Invalid data provided');
      } else {
        toast.error(error.response?.data?.message || `Failed to ${isEditMode ? 'update' : 'create'} department`);
      }
    } finally {
      setLoading(false);
    }
  };

  // Handle close
  const handleClose = () => {
    setFormData({
      name: '',
      description: ''
    });
    setFormErrors({});
    setLoading(false);
    onClose();
  };

  // Get form title
  const getTitle = () => {
    if (isViewMode) return 'View Department';
    if (isEditMode) return 'Edit Department';
    return 'Create New Department';
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className={`fixed inset-0 top-[57px] md:top-[65px] bg-black transition-opacity duration-300 z-50 ${
          isOpen ? 'bg-opacity-50' : 'bg-opacity-0 pointer-events-none'
        }`}
        onClick={handleClose}
      />

      {/* Offcanvas */}
      <div
        className={`fixed top-[57px] md:top-[65px] right-0 h-full w-full max-w-3xl bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="h-full flex flex-col">
          {/* Header */}
          <div className="flex justify-between items-center p-6 border-b">
            <h2 className="text-xl font-bold text-gray-800">
              {getTitle()}
            </h2>
            <button
              onClick={handleClose}
              className="text-gray-500 hover:text-gray-700 p-1"
              disabled={loading}
            >
              <FaTimes className="text-xl" />
            </button>
          </div>

          {/* Form */}
          <div className="flex-1 overflow-y-auto p-6">
            <form onSubmit={handleSubmit}>
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Department Name {!isViewMode && <span className="text-red-500">*</span>}
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  disabled={isViewMode || loading}
                  className={`w-full px-3 py-2 text-sm sm:text-base border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${
                    formErrors.name ? 'border-red-500' : 'border-gray-300'
                  } ${(isViewMode || loading) ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  placeholder="Enter department name"
                />
                {formErrors.name && !isViewMode && (
                  <p className="mt-1 text-sm text-red-600">{formErrors.name}</p>
                )}
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Description
                </label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  disabled={isViewMode || loading}
                  rows="4"
                  className={`w-full px-3 py-2 text-sm sm:text-base border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${
                    formErrors.description ? 'border-red-500' : 'border-gray-300'
                  } ${(isViewMode || loading) ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  placeholder="Enter department description (optional)"
                />
                {formErrors.description && !isViewMode && (
                  <p className="mt-1 text-sm text-red-600">{formErrors.description}</p>
                )}
                {!isViewMode && (
                  <p className="mt-1 text-xs text-gray-500">
                    {formData.description.length}/200 characters
                  </p>
                )}
              </div>

              {/* Loading indicator */}
              {loading && !isViewMode && (
                <div className="mb-4 text-center">
                  <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-red-500"></div>
                  <p className="mt-2 text-sm text-gray-600">
                    {isEditMode ? 'Updating department...' : 'Creating department...'}
                  </p>
                </div>
              )}

              {/* Form Actions */}
              {!isViewMode && (
                <div className="flex gap-3 pt-4">
                  <button
                    type="button"
                    onClick={handleClose}
                    className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 text-sm sm:text-base transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    disabled={loading}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="flex-1 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base transition-colors"
                    disabled={loading}
                  >
                    {loading ? (
                      <span className="flex items-center justify-center">
                        <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></span>
                        {isEditMode ? 'Updating...' : 'Creating...'}
                      </span>
                    ) : (
                      isEditMode ? 'Update' : 'Create'
                    )}
                  </button>
                </div>
              )}

              {isViewMode && (
                <div className="pt-4">
                  <button
                    type="button"
                    onClick={handleClose}
                    className="w-full px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 text-sm sm:text-base transition-colors"
                  >
                    Close
                  </button>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default DepartmentForm;
